import type { ISelectItem } from "@/types"

export const fonts: ISelectItem[] = [
  { label: "Select a font", value: null, disabled: true },
  { label: "Comfortaa", value: "Comfortaa" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Gwendolyn", value: "Gwendolyn" },
  { label: "Antic Slab", value: "Antic+Slab" },
  { label: "Bellota", value: "Bellota" },
  { label: "Buenard", value: "Buenard" },
  { label: "Antonio", value: "Antonio" },
  { label: "DM Sans", value: "DM+Sans" },
  { label: "DM Serif Text", value: "DM+Serif+Text" },
  { label: "Inter", value: "Inter" },
  { label: "Poppins", value: "Poppins" },
  { label: "Raleway", value: "Raleway" },
  { label: "Roboto", value: "Roboto" },
  { label: "Rufina", value: "Rufina" },
  { label: "Average Sans", value: "Average+Sans" },
  { label: "Quicksand", value: "Quicksand" },
  { label: "Andika", value: "Andika" },
  { label: "Philosopher", value: "Philosopher" },
  { label: "Amatic SC", value: "Amatic+SC" },
  { label: "Syne", value: "Syne" },
  { label: "Playfair Display", value: "Playfair+Display" },
  { label: "Italiana", value: "Italiana" },
  { label: "Didact Gothic", value: "Didact+Gothic" },
  { label: "Karla", value: "Karla" },
  { label: "Mulish", value: "Mulish" },
  { label: "Quattrocento", value: "Quattrocento" },
  { label: "Roboto Flex", value: "Roboto+Flex" },
  { label: "Work Sans", value: "Work+Sans" },
  { label: "Marcellus", value: "Marcellus" },
]
